<template>
  <div
    ref="$video"
  >
    <slot />
  </div>
</template>

<script>
import Plyr from 'plyr'

export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    poster: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      plyr: undefined,
    }
  },
  mounted() {
    this.plyr = new Plyr(this.$refs.$video, {
      autoplay: true,
      muted: true,
      loop: { active: true },
      clickToPlay: false,
      controls: [],
      settings: [],
      fullscreen: {
        enabled: false,
      },
    })

    this.plyr.poster = this.poster
  },
}
</script>

<style>
.plyr__poster {
  background-size: cover;
}
</style>
